export class UnidadAcademica {

  constructor(public ID_UnidadAcademica: string,
              public Nombre: string,
              public Titulo: string,
              public Tipo: string) {}
}



// WEBPACK FOOTER //
// ./src/app/shared/dominio/unidadacademica.ts